import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/Poshmark-Share-Groups';

export default function Example() {
  return (
    <>
      <Head>
        <title>Sharing is Caring: What to Know About Poshmark Share Groups</title>
        <meta
          name='description'
          content="Poshmark Share Groups allow Poshers to share an item from their closet that someone else might want to purchase. These groups are based on specific interests or style preferences, so they're easy for shoppers to find what they're looking for."
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/Poshmark-Share-Groups' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/Poshmark-Share-Groups' />
        <meta property='og:title' content='Sharing is Caring: What to Know About Poshmark Share Groups' />
        <meta
          property='og:description'
          content="Poshmark Share Groups allow Poshers to share an item from their closet that someone else might want to purchase. These groups are based on specific interests or style preferences, so they're easy for shoppers to find what they're looking for."
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:modified_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:tag' content='Poshmark' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
